import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { IssueCardModel } from "../../models/issue-card.model";



@Component({
  selector: 'app-issue-viewer',
  templateUrl: './issue-viewer.component.html',
  styleUrls: ['./issue-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssueViewerComponent implements OnInit {


  public issueCardModels: IssueCardModel[] = [
    { title: 'Issue Title 1', description: 'Description for issue 1', locationText: 'Location 1', created: new Date('2023-11-21'), isNew: false, severity: 2 },
    { title: 'Issue Title 2', description: 'Description for issue 2', locationText: 'Location 2', created: new Date('2023-09-23'), isNew: false, severity: 3 },
    { title: 'Issue Title 3', description: 'Description for issue 3', locationText: 'Location 3', created: new Date('2023-11-11'), isNew: true, severity: 2 },
    { title: 'Issue Title 4', description: 'Description for issue 4', locationText: 'Location 4', created: new Date('2023-12-11'), isNew: true, severity: 5 },
    { title: 'Issue Title 5', description: 'Description for issue 5', locationText: 'Location 5', created: new Date('2023-07-19'), isNew: false, severity: 2 },
    { title: 'Issue Title 6', description: 'Description for issue 6', locationText: 'Location 6', created: new Date('2023-01-17'), isNew: true, severity: 2 },
    { title: 'Issue Title 7', description: 'Description for issue 7', locationText: 'Location 7', created: new Date('2023-01-05'), isNew: true, severity: 4 },
    { title: 'Issue Title 8', description: 'Description for issue 8', locationText: 'Location 8', created: new Date('2023-04-11'), isNew: false, severity: 4 },
    { title: 'Issue Title 9', description: 'Description for issue 9', locationText: 'Location 9', created: new Date('2023-07-31'), isNew: true, severity: 5 },
    { title: 'Issue Title 10', description: 'Description for issue 10', locationText: 'Location 10', created: new Date('2023-07-30'), isNew: true, severity: 2 },
    { title: 'Issue Title 11', description: 'Description for issue 11', locationText: 'Location 11', created: new Date('2023-03-17'), isNew: false, severity: 1 },
    { title: 'Issue Title 12', description: 'Description for issue 12', locationText: 'Location 12', created: new Date('2023-06-25'), isNew: true, severity: 2 },
    { title: 'Issue Title 13', description: 'Description for issue 13', locationText: 'Location 13', created: new Date('2023-10-09'), isNew: true, severity: 2 },
    { title: 'Issue Title 14', description: 'Description for issue 14', locationText: 'Location 14', created: new Date('2023-03-13'), isNew: true, severity: 3 },
    { title: 'Issue Title 15', description: 'Description for issue 15', locationText: 'Location 15', created: new Date('2023-07-02'), isNew: true, severity: 4 },
    { title: 'Issue Title 16', description: 'Description for issue 16', locationText: 'Location 16', created: new Date('2023-01-20'), isNew: false, severity: 3 },
    { title: 'Issue Title 17', description: 'Description for issue 17', locationText: 'Location 17', created: new Date('2023-03-27'), isNew: true, severity: 1 },
    { title: 'Issue Title 18', description: 'Description for issue 18', locationText: 'Location 18', created: new Date('2023-07-02'), isNew: true, severity: 5 },
    { title: 'Issue Title 19', description: 'Description for issue 19', locationText: 'Location 19', created: new Date('2023-09-04'), isNew: false, severity: 4 },
    { title: 'Issue Title 20', description: 'Description for issue 20', locationText: 'Location 20', created: new Date('2023-10-18'), isNew: true, severity: 5 }
  ];

  public selectedIssueId: number | null = null;

  constructor(public cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {

    if (this.issueCardModels.length>0) {

      this.selectedIssueId = 0;
    }
  }

  selectIssue(issueId: number) {

    this.selectedIssueId = issueId;
  }


  getSelectedIssue(): IssueCardModel {

    if (this.issueCardModels.length > 0) {

      return this.issueCardModels[this.selectedIssueId];
    }

    return null;
  }



}


 

